import { format, isValid } from 'date-fns';
import { useEffect } from 'react';
import { useDispatch } from '../../../core/hooks/redux';
import { setOrganizations } from '../../../core/redux/leftFilterState';
import {
  CalendarView,
  calendarViews,
  view as viewType,
} from '../../../core/types/util/calendarView';
import { PageName } from '../../../core/types/util/pageName';
import { useUrl } from '../../../shared/hooks/params';

export const useDefaultUrlParams = (page: PageName) => {
  const dispatch = useDispatch();
  const [{ date: urlDate, view: rawView, orgs }, change, remove] = useUrl();
  const setParams = (params: Record<string, string>) => {
    change(page === 'project' ? '/prosjekt' : '/mannskap', params);
  };

  useEffect(() => {
    if (orgs !== undefined) {
      dispatch(setOrganizations(orgs.split(',')
        .map((o) => parseInt(o, 10))
        .filter((o) => o)));
      remove(page === 'project' ? '/prosjekt' : '/mannskap', ['orgs']);
    }
    const params: {view?: string, date?: string } = {};
    if (!rawView || !calendarViews.includes(rawView as CalendarView)) {
      params.view = viewType.month;
    }
    if (!urlDate || !isValid(new Date(urlDate))) {
      params.date = format(new Date(), 'yyyy-MM-dd');
    }
    if (Object.keys(params).length > 0) {
      setParams(params);
    }
  }, [rawView]);
};
